// extracted by mini-css-extract-plugin
export default {"button":"buttonRectangle_button__OKb2h"};